import { render, staticRenderFns } from "./listvip.vue?vue&type=template&id=cf76fa38&scoped=true&"
import script from "./listvip.vue?vue&type=script&lang=js&"
export * from "./listvip.vue?vue&type=script&lang=js&"
import style0 from "./listvip.vue?vue&type=style&index=0&id=cf76fa38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf76fa38",
  null
  
)

export default component.exports